import _ from 'lodash';
import { createContext, useContext, useReducer } from 'react';

const HoverContext = createContext(null);

const HoverDispatchContext = createContext(null);

export function HoverProvider({ children }) {
  const [selection, dispatch] = useReducer(hoverReducer, initialSelection);

  return (
    <HoverContext.Provider value={selection}>
      <HoverDispatchContext.Provider value={dispatch}>{children}</HoverDispatchContext.Provider>
    </HoverContext.Provider>
  );
}

export function useHover() {
  return useContext(HoverContext);
}

export function useHoverDispatch() {
  return useContext(HoverDispatchContext);
}

function hoverReducer(state, action) {
  // console.log('selection-context.hoverReducer(): state = %o, action = %o', state, action);
  let newState = _.cloneDeep(state);
  switch (action.type) {
    case 'phase-hovered': {
      newState.phaseIds = _.uniq([...newState.phaseIds, ..._.castArray(action.phaseIds)]);
      break;
    }
    case 'phase-unhovered': {
      newState.phaseIds = _.remove(newState.phaseIds, ..._.castArray(action.phaseIds));
      break;
    }
    case 'role-hovered': {
      newState.roleIds = _.uniq([...newState.roleIds, ..._.castArray(action.roleIds)]);
      // console.log('newState.roleIds = %o', newState.roleIds);
      break;
    }
    case 'role-unhovered': {
      newState.roleIds = _.remove(newState.roleIds, ..._.castArray(action.roleIds));
      break;
    }
    case 'activity-hovered': {
      newState.activityIds = _.uniq([...newState.activityIds, ..._.castArray(action.activityIds)]);
      break;
    }
    case 'activity-unhovered': {
      newState.activityIds = _.remove(newState.activityIds, ..._.castArray(action.activityIds));
      break;
    }
    case 'cleared': {
      newState = initialSelection;
      break;
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
  return newState;
}

const initialSelection = { phaseIds: [], roleIds: [], activityIds: [] };
